/* Sales Order Store */

import {
  fetchSalesOrder,
  fetchSalesOrderStatuses,
  fetchSalesOrderLineItems,
  fetchSalesOrderStatusChanges,
  fetchClient,
  fetchSalesOrderIssues,
  fetchSalesOrderPhotos,
  fetchSalesOrderLockNotes,
  fetchSalesOrderTracking,
  fetchSalesOrderAddresses,
  updateSalesOrderStatus,
  updateSalesOrderNotes,
  updateSalesOrderHot,
  updateSalesOrderSelect,
  updateSalesOrderLocked,
  fetchRelatedSalesOrderFiles,
  uploadRelatedSalesOrderFile
} from '@/api'

const getInitialState = () => {
  return {
    salesOrder: {
      sono: '',
      custno: '',
      salesmnName: '',
      salesmnPhoto: '',
      addUserName: '',
      addUserPhoto: '',
      salesPerson: '',
      addedBy: '',
      po: '',
      addedOn: '',
      printed: '',
      status: '',
      statusId: '',
      notes: [],
      web: 0,
      hot: 0,
      select: 0,
      locked: 0
    },
    tracking: {
      count: 0,
      tracking: []
    },
    statuses: [],
    lineItems: [],
    statusChanges: {
      count: 0,
      updates: []
    },
    clientNotes: [],
    notes: [],
    issues: {
      count: 0,
      issues: []
    },
    photos: {
      count: 0,
      photos: []
    },
    lockNotes: {
      count: 0,
      notes: []
    },
    files: {
      count: 0,
      files: [],
      options: []
    },
    addresses : []
  }
}

let state = getInitialState()

const actions = {
  resetSalesOrder (context) {
    context.commit('resetSalesOrder')
  },
  fetchSalesOrder (context, salesOrderNumber) {
    return fetchSalesOrder(salesOrderNumber).then((response) => {
      context.commit('setSalesOrder', response.data)
      return response.data
    })
  },
  fetchSalesOrderLineItems (context, salesOrderNumber) {
    return fetchSalesOrderLineItems(salesOrderNumber).then((response) => {
      context.commit('setSalesOrderLineItems', response.data)
    })
  },
  fetchSalesOrderStatuses (context) {
    return fetchSalesOrderStatuses().then((response) => {
      context.commit('setSalesOrderStatuses', response.data)
    })
  },
  fetchSalesOrderStatusChanges (context, salesOrderNumber) {
    return fetchSalesOrderStatusChanges(salesOrderNumber).then((response) => {
      context.commit('setSalesOrderStatusChanges', response.data)
    })
  },
  fetchClientNotes (context, clientCode) {
    return fetchClient(clientCode).then((response) => {
      context.commit('setClientNotes', response.data)
    })
  },
  fetchSalesOrderIssues (context, salesOrderNumber) {
    return fetchSalesOrderIssues(salesOrderNumber).then((response) => {
      context.commit('setSalesOrderIssues', response.data)
    })
  },
  fetchSalesOrderPhotos (context, salesOrderNumber) {
    return fetchSalesOrderPhotos(salesOrderNumber).then((response) => {
      context.commit('setSalesOrderPhotos', response.data)
    })
  },
  fetchSalesOrderLockNotes (context, salesOrderNumber) {
    return fetchSalesOrderLockNotes(salesOrderNumber).then((response) => {
      context.commit('setSalesOrderLockNotes', response.data)
    })
  },
  fetchSalesOrderTracking (context, salesOrderNumber) {
    return fetchSalesOrderTracking(salesOrderNumber).then((response) => {
      context.commit('setSalesOrderTracking', response.data)
    })
  },
  fetchSalesOrderAddresses (context, sono) {
    return fetchSalesOrderAddresses(sono).then( r => {
      context.commit('setSalesOrderAddresses', r.data)
    })
  },
  updateSalesOrderStatus (context, payload) {
    return updateSalesOrderStatus(payload)
  },
  updateSalesOrderNotes (context, payload) {
    return updateSalesOrderNotes(payload)
  },
  updateSalesOrderHot (context, payload) {
    return updateSalesOrderHot(payload)
  },
  updateSalesOrderSelect (context, payload) {
    return updateSalesOrderSelect(payload)
  },
  updateSalesOrderLocked (context, payload) {
    return updateSalesOrderLocked(payload)
  },
  fetchRelatedSalesOrderFiles (context, salesOrderNumber) {
    return fetchRelatedSalesOrderFiles(salesOrderNumber).then((response) => {
      context.commit('setRelatedSalesOrderFiles', response.data)
    })
  },
  uploadRelatedSalesOrderFile (context, payload) {
    return uploadRelatedSalesOrderFile(payload)
  }
}

const mutations = {
  resetSalesOrder (state) {
    Object.assign(state, getInitialState())
  },
  setSalesOrder (state, payload) {
    state.salesOrder = payload
  },
  setSalesOrderLineItems (state, payload) {
    state.lineItems = payload
  },
  setSalesOrderStatuses (state, payload) {
    state.statuses = payload
  },
  setSalesOrderStatusChanges (state, payload) {
    state.statusChanges = payload
  },
  setClientNotes (state, payload) {
    state.clientNotes = payload.notes
  },
  setSalesOrderIssues (state, payload) {
    state.issues = payload
  },
  setSalesOrderPhotos (state, payload) {
    state.photos = payload
  },
  setSalesOrderLockNotes (state, payload) {
    state.lockNotes = payload
  },
  setSalesOrderTracking (state, payload) {
    state.tracking = payload
  },
  setRelatedSalesOrderFiles (state, payload) {
    state.files = payload
  },
  setSalesOrderAddresses (state, payload) {
    state.addresses = payload
  }
}

const getters = {
  getSalesOrder (state) {
    return state.salesOrder
  },
  getSalesOrderStatuses (state) {
    return state.statuses
  },
  getSalesOrderAddresses (state) {
    return state.addresses
  }
  // TODO: Write the rest of the getters.
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
